/*
 * @Author: your name
 * @Date: 2020-12-03 20:35:44
 * @LastEditTime: 2021-08-06 17:09:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\components\mall-public\api.js
 */
let api = {
  // 商城公共头部、底部、购物车数量、当前地址等公共信息
  homeBasic: {
    url: '/mall/home/base',
    type: 'post',
    parameter: {
      set: Array,
      pageCode: Number
    }
  },
  // 页面配置详情获取（根据code获取）
  pageGet: {
    url: '/mall/page/get',
    type: 'post'
  },
  pageName: {
    url: '/mall/home/pageName',
    type: 'post'
  },
  // 顶部退出
  exit: {
    url: '/userauth/userLogout/logout?clientType=mall'
  },
  // 商城首页顶部帮助中心权限
  isOpenMenu: {
    url: '/mall/mallQuestionSearch/checkIsEnable',
    type: 'get'
  },
  // 前台类目
  mallCategory: {
    url: '/mall/mallCategory/getMallCategory',
    type: 'get'
  },
  // 获取供应商信息
  getSupplyInfo: {
    url: '/mall/itemdetail/information',
    type: 'get',
    parameter: {
      id: Number // 供应商id
    }
  },
  // 获取供应商评分
  getSupplierEvalInfo: {
    url: '/mall/product/eval/getSupplierEvalInfo',
    type: 'post',
    parameter: {
      supplierId: Number
    }
  },
  // 是否显示热搜
  hotSearchConfig: {
    url: '/mall/search/mallHotSearchConfig',
    type: 'post'
  },
  // 获取热搜列表
  hotSearch: {
    url: '/mall/search/purchaserKeyWordHotSearch',
    type: 'post'
  },
  // 获取语言列表
  getLanguage: {
    url: '/mall/language',
    type: 'get'
  },
  searchVague: {
    url: '/mall/search/suggest',
    type: 'post',
    parameter: {
      pageSize: Number
    }
  },
  // 获取用户仓库
  getWarehouse: {
    type: 'get',
    url: 'mall/user/warehouse/get'
  },
  // 设置用户仓库
  setWarehouse: {
    type: 'post',
    url: '/mall/user/warehouse/set'
  },
  // 获取全部仓库
  warehouseAll: {
    type: 'post',
    url: '/mall/warehouse/all'
  },
  // 列表页添加购物车选择仓库
  warehouseList: {
    type: 'post',
    url: '/mall/warehouse/list'
  },
  // 是否启用领用规则
  isEnbleRule: {
    url: '/mall/nologin/rule/objValue?key=recipients_type_config',
    type: 'get'
  },
  // 订单列表统计
  getCount: {
    url: '/mall/order/count',
    type: 'get'
  },
  listByRuleKey: {
    type: 'post',
    url: '/mall/rule/execute/listByRuleKey'
  },
  listByRuleKeyNoLogin: {
    type: 'post',
    url: '/mall/nologin/rule/listByRuleKey'
  },
  // 根据物料编码获取领用商品数量
  getInvMallCount: {
    url: '/mall/search/getInvMallCount',
    type: 'post'
  },
  areaApi: {
    list: {
      url: '/mall/cityarea/get?id=0',
      type: 'get',
      parameter: {}
    },
    get: {
      url: '/mall/cityarea/get',
      type: 'get',
      parameter: {}
    }
  },
  // 商品范围页面获取设置的查询条件
  querySearchParam: {
    url: '/mall/pageMallSku/querySearchParam',
    type: 'post'
  },
  // 列表搜索
  purchaser: {
    url: '/mall/search/index',
    type: 'post',
    parameter: {
      cid: String, // 分类id
      q: String, // 查询的关键字,
      s: String, // 价格排序，1-升序，2-降序
      to: String, // 配送地区
      sName: String, // 供应商名称
      pageSize: Number, // 默认每页显示30条
      pageNo: Number
    }
  },
  // 查询搜索列表商品的同款数量
  sameNumber: {
    url: '/mall/search/sameNumber',
    type: 'post',
    parameter: {
      list: Array
    }
  },
  // 价格特性规则
  contractPriceCharacteristic: {
    url: '/mall/rule/execute/objValue?key=contract_enable_price_characteristic',
    type: 'get'
  },
  checkSku: {
    url: '/mall/product/cart/checkSku',
    type: 'post',
    parameter: {
      provinceCode: Number,
      cityCode: Number,
      countyCode: Number,
      townCode: Number,
      mallItemSkuId: Number,
      count: Number
    }
  },
  // 租户是否开通京东
  getUserJDConfig: {
    url: '/mall/product/supplier/hasjd',
    type: 'get'
  },
  // 是否京东供应商
  getJDSupplierInfo: {
    url: '/mall/product/supplier/isjd',
    type: 'post'
  },
  // 添加购物车
  addCart: {
    url: '/mall/product/addCart',
    type: 'post',
    parameter: {
      catalogingType: Number, // 1 目录化 0 非目录化
      categoryTagId: Number, // 标签分类id（必填）
      isTemplate: Number,   // 是否是模板商品
      protocalId: Number, // 协议id（必填）
      itemSkuId: Number, // 供应商id（必填）
      supplierId: Number, // 数量（必填）
      purchasedAmount: String,   // 城市code（必填）
      cityCode: String,   // 城市code（必填）
      provinceCode: Number, // 数量（必填）
      protocalPriceId: Number, // 供应商id（必填）
      marketId: String,  // 卡套卡绳类商品  electronicSkuId（有就传）
      content: [ // 模板商品（必填） 非模板不传
        {
          amount: Number, // 模板商品单行数量
          content: String, // json字符串 用于购物车详情显示
          marketId: String,
          supplierItemAttributeTemplateId: Number, // 模板表头id预留字段，现在写死的1要不后台报错
          itemTemplateCode: String // 模板code
        }
      ]
    }
  },
  // 获取店铺名称
  getSupplierName: {
    url: '/mall/search/lyljMallName',
    type: 'get'
  },
  // 领用/利旧库存组织
  stockOrgList: {
    url: '/mall/stock/stockOrgAndWarehouse',
    type: 'post'
  },
  // 领用/利旧仓库列表
  stockSiteList: {
    url: '/mall/stock/stockOrgAndWarehouse',
    type: 'post'
  },
  // 商城规则
  mallSetting: {
    url: '/mall/product/rule/mallSetting',
    type: 'get'
  },
  getSupplyInfoBySuId: {
    url: '/mall/product/supplier/info',
    type: 'get'
  },
  // 通用接口配置
  getRuleStringValue: {
    url: '/mall/rule/execute/stringValue',
    // url: '/mall/nologin/rule/stringValue',
    type: 'get',
    parameter: {
      key: String
    }
  }
}
export default api
